import React from 'react'

import { PerksSignupComponentKey, RoutesMapping, SectionType } from 'adminSignUp'

import MakePaymentValues from 'core/application/adminSignUp/makePayment'
import perksAchPaymentApi from 'core/application/adminSignUp/perks/achPayment'
import perksMakeCreditCardPayment from 'core/application/adminSignUp/perks/creditCardPayment'
import { ProductIds } from 'core/application/commons/config'

import { BaseNavigationProps } from '../../../common/wizard/BaseNavigationProps'
import MakePayment from '../../common/MakePayment'

const PerksMakePayment: React.FC<BaseNavigationProps<MakePaymentValues>> = (props) => {
  const Steps = RoutesMapping.get(ProductIds.Perks).filter((i) => i.sectionType === SectionType.SUBSCRIPTION)

  return (
    <MakePayment
      achPaymentHandler={(recurlyToken, billingEmail) =>
        perksAchPaymentApi({
          recurlyToken,
          billingEmail,
        })
      }
      creditCardPaymentHandler={(recurlyToken, frequency) =>
        perksMakeCreditCardPayment({
          recurlyToken,
          frequency,
        })
      }
      numberOfSteps={Steps.length}
      currentStep={Steps.findIndex((i) => i.key === PerksSignupComponentKey.SUBSCRIPTION_MAKE_PAYMENT) + 1}
      {...props}
    />
  )
}

export default PerksMakePayment
